(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootNodes = document.querySelectorAll('[data-recently-viewed-products]');

    if (!rootNodes.length) {
      return;
    }

    const parseStoredHandles = (value) => {
      if (!value) {
        return [];
      }

      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed.filter((item) => typeof item === 'string' && item.length > 0);
        }
      } catch (error) {
        return [];
      }

      return [];
    };

    const writeStoredHandles = (storageKey, handles) => {
      localStorage.setItem(storageKey, JSON.stringify(handles));
    };

    const readStoredHandles = (storageKey) => {
      return parseStoredHandles(localStorage.getItem(storageKey));
    };

    const formatMoney = (cents, moneyFormat, currencyCode) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(cents / 100);
    };

    const recordCurrentProduct = (storageKey, currentHandle) => {
      if (!currentHandle) {
        return;
      }

      const handles = readStoredHandles(storageKey).filter((handle) => handle !== currentHandle);
      handles.unshift(currentHandle);
      writeStoredHandles(storageKey, handles.slice(0, 20));
    };

    const renderItem = (product, moneyFormat, currencyCode) => {
      const item = document.createElement('li');
      item.className = 'recently-viewed-products__item';

      const imageMarkup = product.featured_image
        ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="360" height="360">`
        : '<div class="recently-viewed-products__image-placeholder" aria-hidden="true"></div>';

      const comparePriceMarkup =
        product.compare_at_price && product.compare_at_price > product.price
          ? `<span class="recently-viewed-products__price--compare">${formatMoney(
              product.compare_at_price,
              moneyFormat,
              currencyCode
            )}</span>`
          : '';

      item.innerHTML = `
        <a class="recently-viewed-products__link" href="${product.url}" aria-label="${product.title}">
          <span class="recently-viewed-products__image">${imageMarkup}</span>
          <span class="recently-viewed-products__content">
            <span class="recently-viewed-products__name">${product.title}</span>
            <span class="recently-viewed-products__prices">
              <span class="recently-viewed-products__price">${formatMoney(
                product.price,
                moneyFormat,
                currencyCode
              )}</span>
              ${comparePriceMarkup}
            </span>
          </span>
        </a>
      `;

      return item;
    };

    const fetchProduct = async (handle) => {
      const response = await fetch(`/products/${handle}.js`);

      if (!response.ok) {
        throw new Error(`Failed to fetch product for handle: ${handle}`);
      }

      return response.json();
    };

    rootNodes.forEach(async (rootNode) => {
      const storageKey = rootNode.dataset.storageKey;
      const currentHandle = rootNode.dataset.currentHandle;
      const excludedHandle = rootNode.dataset.excludeHandle;
      const limit = Number(rootNode.dataset.limit) || 4;
      const moneyFormat = rootNode.dataset.moneyFormat;
      const currencyCode = rootNode.dataset.currencyCode;
      const emptyText = rootNode.dataset.emptyText || 'No recently viewed products yet.';

      const listNode = rootNode.querySelector('[data-recently-viewed-list]');
      const emptyNode = rootNode.querySelector('[data-recently-viewed-empty]');

      if (!storageKey || !listNode || !emptyNode) {
        return;
      }

      recordCurrentProduct(storageKey, currentHandle);

      const handles = readStoredHandles(storageKey)
        .filter((handle) => handle !== excludedHandle)
        .slice(0, limit);

      if (!handles.length) {
        emptyNode.textContent = emptyText;
        emptyNode.hidden = false;
        listNode.innerHTML = '';
        return;
      }

      const products = await Promise.all(
        handles.map(async (handle) => {
          try {
            return await fetchProduct(handle);
          } catch (error) {
            return null;
          }
        })
      );

      const validProducts = products.filter((product) => product);

      if (!validProducts.length) {
        emptyNode.textContent = emptyText;
        emptyNode.hidden = false;
        listNode.innerHTML = '';
        return;
      }

      const fragment = document.createDocumentFragment();
      validProducts.forEach((product) => {
        fragment.appendChild(renderItem(product, moneyFormat, currencyCode));
      });

      listNode.innerHTML = '';
      listNode.appendChild(fragment);
      emptyNode.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
